import { api } from '../api'

// todo interface
type IMediaResponse = {
  data?: any
  current_page?: number
  first_page?: number
  last_page?: number
}

export const mediaApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getMedia: builder.query<
      IMediaResponse,
      { developerId: number; payload?: any }
    >({
      query: ({ developerId, payload }) => {
        return {
          url: `/companies/${developerId}/media`,
          params: payload,
        }
      },
      providesTags: <any>['Media'],
    }),
    getSingleMedia: builder.query<
      IMediaResponse,
      { developerId: number; media: number }
    >({
      query: ({ developerId, media }) => {
        return {
          url: `/companies/${developerId}/media/${media}`,
        }
      },
    }),
    addMedia: builder.mutation({
      query: ({ developerId, payload }) => {
        const formData = new FormData()
        Object.keys(payload).forEach((key) =>
          formData.append(key, payload[key]),
        )
        return {
          url: `/companies/${developerId}/media`,
          method: 'POST',
          body: formData,
        }
      },
      invalidatesTags: <any>['Media'],
    }),
    updateMedia: builder.mutation({
      query: ({ developerId, media, data }) => {
        return {
          url: `/companies/${developerId}/media/${media}`,
          method: 'PATCH',
          body: data,
        }
      },
      invalidatesTags: <any>['Media'],
    }),
    deleteMedia: builder.mutation({
      query: ({ developerId, media }) => {
        return {
          url: `/companies/${developerId}/media/${media}`,
          method: 'DELETE',
        }
      },
      invalidatesTags: <any>['Media'],
    }),
    requestNewMedia: builder.mutation({
      query: ({ developerId, payload }) => {
        const formData = new FormData()
        Object.keys(payload).forEach((key) =>
          formData.append(key, payload[key]),
        )

        formData.append('developer_id', developerId)

        return {
          url: `/companies/${developerId}/media/requests`,
          method: 'POST',
          body: formData,
        }
      },
    }),
  }),
})

export const {
  useGetMediaQuery,
  useGetSingleMediaQuery,
  useAddMediaMutation,
  useUpdateMediaMutation,
  useDeleteMediaMutation,
  useRequestNewMediaMutation,
} = mediaApi
